import { AllocationViewActionIdentifierModel, AllocationViewTruckReleaseModel } from '../../models';

export class AllocationViewTruckReleaseAction {
  public static readonly type = '[AllocationViewTruckReleaseAction] Truck Release';

  constructor(public data: AllocationViewTruckReleaseModel) {}
}

export class AllocationViewTruckReleaseActionPrepare {
  public static readonly type = '[AllocationViewTruckReleaseAction] Truck Release Prepare';

  constructor(public identifier: AllocationViewActionIdentifierModel, public language: string) {}
}

export class AllocationViewTruckReleaseActionSetInitialState {
  public static readonly type = '[AllocationViewTruckReleaseAction] Set Initial State';
}
